import React from 'react';
// @ts-ignore
import generalStyles from '../../assets/styles/generalStyle.module.scss';

export const SmallModal = props => {
    return (
        <>
            <div className="row">
                <div className="col-sm-12">{props.children}</div>
            </div>
        </>
    );
};

export const LargeModal = props => {
    return (
        <>
            <div className="row">
                <div className={'col-sm-12'}>
                    <div className={'col-sm-9 col-sm-offset-3'}>
                        {props.children}
                    </div>
                </div>
            </div>
        </>
    );
};

export const ButtonRelatedToRows = props => {
    return (
        <div className={generalStyles['button-inline-block']}>
            {props.children}
        </div>
    );
};

export const PrimaryButton = props => {
    return (
        <>
            <div className={generalStyles['small-modal-primary']}>
                {props.children}
            </div>
        </>
    );
};

export const SecondaryButton = props => {
    return (
        <div className={generalStyles['small-modal-secondary']}>
            {props.children}
        </div>
    );
};

export const TertiaryButton = props => {
    return (
        <div className={'container'}>
            <div className={'row'}>
                <div className={'col-sm-10'}>
                    <div className={'col-sm-3 col-sm-offset-2'}>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export const TabWrapper = props => {
    return (
        <>
            <div className="row">
                <div className={'col-sm-12'}>{props.children}</div>
            </div>
        </>
    );
};

export const TabButton = props => {
    return (
        <>
            <div className={generalStyles['tab-button']}>{props.children}</div>
        </>
    );
};
